import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FavoriteButton from '../../components/FavoriteButton/FavoriteButton';
import ShareButton from '../../components/ShareButton/ShareButton';
import css from './RenderActionButtons.scss';

const RenderActionButtons = ({
    location,
    item,
    getTrackingInfo,
    showFavBtn,
    showShareBtn,
    containerClass,
    btnColor,
    btnSize
}) => {
    if (showFavBtn || showShareBtn) {
        return (
            <div data-aut-id="actionBtns" className={ classnames(css.actionButtonContainer, containerClass) }>
                <div className={ classnames(css.actionButtons, { [css.margin]: showFavBtn && showShareBtn }) }>
                    {showShareBtn && <ShareButton
                        path={ location.pathname }
                        title={ item.title }
                        itemId={ item.id }
                        getTrackingInfo={ getTrackingInfo }
                        color={ btnColor }
                        size={ btnSize }
                    />}
                    {showFavBtn && <FavoriteButton
                        name="Favorite"
                        item={ item }
                        getTrackingInfo={ getTrackingInfo }
                        color={ btnColor }
                        size={ btnSize }
                    />}
                </div>
            </div>
        );
    }

    return null;
};

RenderActionButtons.propTypes = {
    location: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    getTrackingInfo: PropTypes.func.isRequired,
    btnSize: PropTypes.number,
    btnColor: PropTypes.string,
    showFavBtn: PropTypes.bool,
    showShareBtn: PropTypes.bool,
    containerClass: PropTypes.string
};

RenderActionButtons.defaultProps = {
    location: {},
    btnSize: 28,
    btnColor: '',
    showFavBtn: false,
    showShareBtn: false,
    containerClass: ''
};

export default React.memo(RenderActionButtons);
